import { useQuery } from "@tanstack/react-query";
import CollaboratorsService from "../services/api/collaborators/Collaborators.service";
import { RefreshReactQuery } from "../constants/AppConstants";
import { useEffect } from "react";
import { useNotification } from "./notification.hook";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../constants/Dictionary";

export const useAvatar = (collaboratorId: number) => {
  const { notification } = useNotification();
  const { data, isError } = useQuery({
    queryKey: [`get-collaborator-image-${collaboratorId}`],
    queryFn: () => CollaboratorsService.getImage(collaboratorId),
    select: (data) =>
      data?.image ? `data:image/jpeg;base64,${data.image}` : null,
    staleTime: RefreshReactQuery.INFINITY,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data };
};
